import api from "@/services/api";
import { ENDPOINTS_PRICE } from "@/services/endpoints";

let cache = null;
let cachedAt = 0;
const TTL = 60_000;

export const getKubPrice = async () => {
  if (cache && Date.now() - cachedAt < TTL) return cache;
  const data = await api.get(ENDPOINTS_PRICE.kub).then((r) => r.data);
  cache = data;
  cachedAt = Date.now();
  return data;
};
